import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';

@Component({
  selector: 'app-event-ticketing-skeleton',
  templateUrl: './event-ticketing-skeleton.component.html',
  styleUrls: ['./event-ticketing-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class EventTicketingSkeletonComponent {}
